import { v4 as uuid } from 'uuid';

import CollectionStoryWithIndex from './CollectionStoryWithIndex';

/** Editable epic in the collection editor; `id` is client-only and never sent to the backend. */
class CollectionEpicWrapper {
  readonly id: string;
  title: string;
  description: string;
  stories: CollectionStoryWithIndex[];

  constructor(
    title: string,
    description: string,
    stories: CollectionStoryWithIndex[],
    id: string = uuid(),
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.stories = stories;
  }
}

export default CollectionEpicWrapper;
